const roster = [
    { owner: "Lyra North", team: "Northern Comets" },
    { owner: "Owen Slate", team: "Steel Kites" },
    { owner: "Priya Vale", team: "Orchard Lanterns" },
    { owner: "Mateo Quill", team: "Quartz Wolves" },
    { owner: "Tessa Bloom", team: "Harbor Foxes" },
    { owner: "Idris Harbor", team: "Ember Owls" },
    { owner: "June Meridian", team: "Signal Rams" },
    { owner: "Elliot Sage", team: "Amber Meteors" },
];

const weekLabels = {
    2: "Week 2",
    7: "Week 7",
    12: "Week 12",
};

const weekOptions = [2, 7, 12];

const attachRoster = (rows) => rows.map((row, index) => ({ ...roster[index], ...row }));

const makeGame = (homeIndex, awayIndex, homeScore, awayScore, meetings, extra = {}) => ({
    home_team: roster[homeIndex].team,
    home_owner: roster[homeIndex].owner,
    away_team: roster[awayIndex].team,
    away_owner: roster[awayIndex].owner,
    home_score: homeScore,
    away_score: awayScore,
    is_final: true,
    h2h: {
        total_meetings: meetings.total,
        home_wins: meetings.homeWins,
        away_wins: meetings.awayWins,
        home_avg_pts: meetings.homeAvg,
        away_avg_pts: meetings.awayAvg,
        playoff_meetings: meetings.playoffMeetings || 0,
        recent_meetings: meetings.recent || [],
    },
    ...extra,
});

const sharedPositionMatrix = {
    categories: ["QB", "RB", "WR", "TE", "D/ST", "K"],
    teams: attachRoster([
        {
            total_points: 1352.6,
            breakdown: {
                QB: 312.4,
                RB: 396.2,
                WR: 374.1,
                TE: 142.0,
                "D/ST": 78.9,
                K: 48.9,
            },
            shares: {
                QB: 0.231,
                RB: 0.293,
                WR: 0.276,
                TE: 0.105,
                "D/ST": 0.058,
                K: 0.036,
            },
        },
        {
            total_points: 1286.3,
            breakdown: {
                QB: 285.0,
                RB: 374.1,
                WR: 344.3,
                TE: 143.8,
                "D/ST": 77.8,
                K: 61.3,
            },
            shares: {
                QB: 0.221,
                RB: 0.291,
                WR: 0.268,
                TE: 0.112,
                "D/ST": 0.061,
                K: 0.048,
            },
        },
        {
            total_points: 1241.5,
            breakdown: {
                QB: 304.7,
                RB: 316.4,
                WR: 392.6,
                TE: 133.2,
                "D/ST": 54.8,
                K: 39.8,
            },
            shares: {
                QB: 0.245,
                RB: 0.255,
                WR: 0.316,
                TE: 0.107,
                "D/ST": 0.044,
                K: 0.032,
            },
        },
        {
            total_points: 1324.9,
            breakdown: {
                QB: 298.9,
                RB: 358.2,
                WR: 377.5,
                TE: 142.5,
                "D/ST": 72.8,
                K: 74.9,
            },
            shares: {
                QB: 0.226,
                RB: 0.270,
                WR: 0.285,
                TE: 0.108,
                "D/ST": 0.055,
                K: 0.056,
            },
        },
        {
            total_points: 1295.6,
            breakdown: {
                QB: 287.2,
                RB: 339.1,
                WR: 363.0,
                TE: 148.7,
                "D/ST": 79.9,
                K: 77.7,
            },
            shares: {
                QB: 0.222,
                RB: 0.262,
                WR: 0.280,
                TE: 0.115,
                "D/ST": 0.062,
                K: 0.060,
            },
        },
        {
            total_points: 1208.2,
            breakdown: {
                QB: 266.1,
                RB: 319.5,
                WR: 347.2,
                TE: 136.3,
                "D/ST": 76.4,
                K: 62.7,
            },
            shares: {
                QB: 0.220,
                RB: 0.264,
                WR: 0.287,
                TE: 0.113,
                "D/ST": 0.063,
                K: 0.052,
            },
        },
        {
            total_points: 1199.7,
            breakdown: {
                QB: 255.8,
                RB: 325.6,
                WR: 348.8,
                TE: 131.1,
                "D/ST": 73.2,
                K: 65.2,
            },
            shares: {
                QB: 0.213,
                RB: 0.271,
                WR: 0.291,
                TE: 0.109,
                "D/ST": 0.061,
                K: 0.054,
            },
        },
        {
            total_points: 1164.8,
            breakdown: {
                QB: 244.7,
                RB: 301.2,
                WR: 340.6,
                TE: 133.7,
                "D/ST": 71.5,
                K: 73.1,
            },
            shares: {
                QB: 0.210,
                RB: 0.259,
                WR: 0.292,
                TE: 0.115,
                "D/ST": 0.061,
                K: 0.063,
            },
        },
        {
            total_points: 1142.9,
            breakdown: {
                QB: 238.4,
                RB: 294.4,
                WR: 336.2,
                TE: 129.4,
                "D/ST": 69.1,
                K: 75.4,
            },
            shares: {
                QB: 0.209,
                RB: 0.258,
                WR: 0.294,
                TE: 0.113,
                "D/ST": 0.061,
                K: 0.066,
            },
        },
    ]),
};

const sharedTeamCards = {
    categories: ["QB", "RB", "WR", "TE", "D/ST", "K"],
    teams: attachRoster([
        {
            total_points: 1352.6,
            breakdown: sharedPositionMatrix.teams[0].breakdown,
            shares: sharedPositionMatrix.teams[0].shares,
            chips: [
                { key: "qb_edge", label: "QB Edge", reason: "Quarterback scoring is carrying a top-tier weekly floor." },
                { key: "lineup_efficiency", label: "Lineup Efficiency", reason: "Best starter decisions in the demo league." },
            ],
            metadata: {
                lineup_efficiency: 0.92,
                bench_points: 214.8,
                trend_windows: {
                    available: true,
                    trailing_average_points: 167.4,
                    prior_average_points: 161.1,
                },
                opponent_breakdown: sharedPositionMatrix.teams[1].breakdown,
            },
        },
        {
            total_points: 1286.3,
            breakdown: sharedPositionMatrix.teams[1].breakdown,
            shares: sharedPositionMatrix.teams[1].shares,
            chips: [
                { key: "rb_core", label: "RB Core", reason: "Running backs supply the safest weekly points on this roster." },
                { key: "balanced_roster", label: "Balanced Roster", reason: "Scoring is spread well across QB, RB, WR, and TE." },
            ],
            metadata: {
                lineup_efficiency: 0.88,
                bench_points: 197.5,
                trend_windows: {
                    available: true,
                    trailing_average_points: 160.8,
                    prior_average_points: 156.7,
                },
                opponent_breakdown: sharedPositionMatrix.teams[0].breakdown,
            },
        },
        {
            total_points: 1241.5,
            breakdown: sharedPositionMatrix.teams[2].breakdown,
            shares: sharedPositionMatrix.teams[2].shares,
            chips: [
                { key: "wr_ceiling", label: "WR Ceiling", reason: "Wide receivers create the biggest path to a spike week." },
                { key: "boom_bust", label: "Boom/Bust", reason: "High weekly upside, but the floor depends on WR touchdowns." },
            ],
            metadata: {
                lineup_efficiency: 0.83,
                bench_points: 188.2,
                trend_windows: {
                    available: true,
                    trailing_average_points: 154.3,
                    prior_average_points: 149.0,
                },
                opponent_breakdown: sharedPositionMatrix.teams[3].breakdown,
            },
        },
        {
            total_points: 1324.9,
            breakdown: sharedPositionMatrix.teams[3].breakdown,
            shares: sharedPositionMatrix.teams[3].shares,
            chips: [
                { key: "rb_heavy", label: "RB-Heavy", reason: "A large share of total scoring comes from the running backs." },
                { key: "safe_floor", label: "Safe Floor", reason: "Consistent starter production keeps dud weeks rare." },
            ],
            metadata: {
                lineup_efficiency: 0.9,
                bench_points: 204.6,
                trend_windows: {
                    available: true,
                    trailing_average_points: 163.9,
                    prior_average_points: 158.2,
                },
                opponent_breakdown: sharedPositionMatrix.teams[2].breakdown,
            },
        },
        {
            total_points: 1295.6,
            breakdown: sharedPositionMatrix.teams[4].breakdown,
            shares: sharedPositionMatrix.teams[4].shares,
            chips: [
                { key: "te_edge", label: "TE Edge", reason: "Tight end output is a weekly advantage against most matchups." },
                { key: "bench_depth", label: "Bench Depth", reason: "Enough bench points to survive injuries and bye weeks." },
            ],
            metadata: {
                lineup_efficiency: 0.87,
                bench_points: 180.4,
                trend_windows: {
                    available: true,
                    trailing_average_points: 156.9,
                    prior_average_points: 152.3,
                },
                opponent_breakdown: sharedPositionMatrix.teams[5].breakdown,
            },
        },
        {
            total_points: 1208.2,
            breakdown: sharedPositionMatrix.teams[5].breakdown,
            shares: sharedPositionMatrix.teams[5].shares,
            chips: [
                { key: "matchup_dependent", label: "Matchup Dependent", reason: "This roster needs the right opponent draw to keep pace." },
                { key: "dst_kicker_boost", label: "D/ST + K Boost", reason: "Defense and kicker points are propping up close weeks." },
            ],
            metadata: {
                lineup_efficiency: 0.81,
                bench_points: 166.8,
                trend_windows: {
                    available: true,
                    trailing_average_points: 149.1,
                    prior_average_points: 143.5,
                },
                opponent_breakdown: sharedPositionMatrix.teams[4].breakdown,
            },
        },
        {
            total_points: 1199.7,
            breakdown: sharedPositionMatrix.teams[6].breakdown,
            shares: sharedPositionMatrix.teams[6].shares,
            chips: [
                { key: "playoff_bubble", label: "Playoff Bubble", reason: "Projected points are close enough to stay in the race." },
                { key: "start_sit_risk", label: "Start/Sit Risk", reason: "Bench points suggest a few lineup calls are still costing wins." },
            ],
            metadata: {
                lineup_efficiency: 0.79,
                bench_points: 172.3,
                trend_windows: {
                    available: true,
                    trailing_average_points: 147.5,
                    prior_average_points: 142.8,
                },
                opponent_breakdown: sharedPositionMatrix.teams[7].breakdown,
            },
        },
        {
            total_points: 1164.8,
            breakdown: sharedPositionMatrix.teams[7].breakdown,
            shares: sharedPositionMatrix.teams[7].shares,
            chips: [
                { key: "needs_wr_help", label: "Needs WR Help", reason: "Wide receiver scoring trails the rest of the league." },
                { key: "low_floor", label: "Low Floor", reason: "Too many points depend on a perfect lineup week." },
            ],
            metadata: {
                lineup_efficiency: 0.77,
                bench_points: 158.9,
                trend_windows: {
                    available: true,
                    trailing_average_points: 142.7,
                    prior_average_points: 139.4,
                },
                opponent_breakdown: sharedPositionMatrix.teams[6].breakdown,
            },
        },
    ]),
};

const buildCupGroup = (name, rows) => ({
    name,
    table: rows,
});

const cupTeams = {
    lyra: {
        provider_team_id: "demo-team-1",
        owner_name: roster[0].owner,
        team_name: roster[0].team,
    },
    owen: {
        provider_team_id: "demo-team-2",
        owner_name: roster[1].owner,
        team_name: roster[1].team,
    },
    priya: {
        provider_team_id: "demo-team-3",
        owner_name: roster[2].owner,
        team_name: roster[2].team,
    },
    mateo: {
        provider_team_id: "demo-team-4",
        owner_name: roster[3].owner,
        team_name: roster[3].team,
    },
    tessa: {
        provider_team_id: "demo-team-5",
        owner_name: roster[4].owner,
        team_name: roster[4].team,
    },
    idris: {
        provider_team_id: "demo-team-6",
        owner_name: roster[5].owner,
        team_name: roster[5].team,
    },
    june: {
        provider_team_id: "demo-team-7",
        owner_name: roster[6].owner,
        team_name: roster[6].team,
    },
    elliot: {
        provider_team_id: "demo-team-8",
        owner_name: roster[7].owner,
        team_name: roster[7].team,
    },
};

const demoCup = {
    config: {
        name: "Lantern Cup",
        start_week: 2,
        group_count: 2,
        bracket_size: 4,
    },
    status: "completed",
    permissions: {
        can_edit: false,
    },
    schedule: {
        group_stage_weeks: [2, 3, 4],
        bracket_size: 4,
        knockout_rounds: [
            { round_index: 1, label: "Semifinals", start_week: 5, end_week: 5 },
            { round_index: 2, label: "Final", start_week: 6, end_week: 6 },
        ],
        wildcard_count: 2,
    },
    groups: [
        buildCupGroup("North Group", [
            {
                ...cupTeams.lyra,
                qualified: true,
                wildcard: false,
                seed: 1,
                group_points_for: 431.66,
                week_scores: { 2: 131.2, 3: 140.9, 4: 159.56 },
            },
            {
                ...cupTeams.mateo,
                qualified: true,
                wildcard: true,
                seed: 3,
                group_points_for: 414.22,
                week_scores: { 2: 128.0, 3: 132.5, 4: 153.72 },
            },
            {
                ...cupTeams.tessa,
                qualified: false,
                wildcard: false,
                group_points_for: 401.75,
                week_scores: { 2: 119.1, 3: 139.7, 4: 142.95 },
            },
            {
                ...cupTeams.elliot,
                qualified: false,
                wildcard: false,
                group_points_for: 356.18,
                week_scores: { 2: 108.6, 3: 117.4, 4: 130.18 },
            },
        ]),
        buildCupGroup("South Group", [
            {
                ...cupTeams.owen,
                qualified: true,
                wildcard: false,
                seed: 1,
                group_points_for: 426.91,
                week_scores: { 2: 134.1, 3: 138.3, 4: 154.51 },
            },
            {
                ...cupTeams.priya,
                qualified: true,
                wildcard: true,
                seed: 4,
                group_points_for: 409.08,
                week_scores: { 2: 121.5, 3: 136.0, 4: 151.58 },
            },
            {
                ...cupTeams.idris,
                qualified: false,
                wildcard: false,
                group_points_for: 397.44,
                week_scores: { 2: 123.7, 3: 127.8, 4: 145.94 },
            },
            {
                ...cupTeams.june,
                qualified: false,
                wildcard: false,
                group_points_for: 352.16,
                week_scores: { 2: 110.2, 3: 115.6, 4: 126.36 },
            },
        ]),
    ],
    bracket: [
        {
            round_index: 1,
            label: "Semifinals",
            start_week: 5,
            end_week: 5,
            is_complete: true,
            matches: [
                {
                    slot: "semi-1",
                    home_seed: 1,
                    away_seed: 4,
                    home: cupTeams.lyra,
                    away: cupTeams.priya,
                    home_week_scores: { 5: 168.54 },
                    away_week_scores: { 5: 154.17 },
                    home_cumulative_score: 168.54,
                    away_cumulative_score: 154.17,
                    home_score: 168.54,
                    away_score: 154.17,
                    winner_provider_team_id: cupTeams.lyra.provider_team_id,
                },
                {
                    slot: "semi-2",
                    home_seed: 1,
                    away_seed: 3,
                    home: cupTeams.owen,
                    away: cupTeams.mateo,
                    home_week_scores: { 5: 163.92 },
                    away_week_scores: { 5: 157.36 },
                    home_cumulative_score: 163.92,
                    away_cumulative_score: 157.36,
                    home_score: 163.92,
                    away_score: 157.36,
                    winner_provider_team_id: cupTeams.owen.provider_team_id,
                },
            ],
        },
        {
            round_index: 2,
            label: "Final",
            start_week: 6,
            end_week: 6,
            is_complete: true,
            matches: [
                {
                    slot: "final",
                    home_seed: 1,
                    away_seed: 1,
                    home: cupTeams.lyra,
                    away: cupTeams.owen,
                    home_week_scores: { 6: 173.28 },
                    away_week_scores: { 6: 167.64 },
                    home_cumulative_score: 173.28,
                    away_cumulative_score: 167.64,
                    home_score: 173.28,
                    away_score: 167.64,
                    winner_provider_team_id: cupTeams.lyra.provider_team_id,
                },
            ],
        },
    ],
    champion: cupTeams.lyra,
};

const makeWeeklySnapshot = ({
    week,
    weekLabel,
    summary,
    awards,
    standings,
    boxScores,
    powerRankings,
    prevPowerRankings,
    ktcData,
    luckIndex,
    naughtyList,
}) => ({
    week,
    weekLabel,
    summary,
    awards,
    standings: attachRoster(standings),
    boxScores,
    powerRankings: attachRoster(powerRankings),
    prevPowerRankings: attachRoster(prevPowerRankings),
    ktcData,
    luckIndex: attachRoster(luckIndex),
    naughtyList,
    seasonMatrix: sharedPositionMatrix,
    teamCards: sharedTeamCards,
    aiReport: {
        title: `${weekLabel} report`,
        subtitle: summary.reportSubtitle,
        narrative: summary.reportNarrative,
        bullets: summary.reportBullets,
        closing: summary.reportClosing,
    },
});

const demoLeagueData = {
    league: {
        name: "Northstar Showcase",
        provider: "demo",
        leagueId: "demo-2025-alpha",
        season: 2025,
        currentWeek: 12,
        ownerCount: roster.length,
        leagueType: "full_box_score",
    },
    weekOptions,
    weekLabels,
    overview: {
        synthetic: true,
        tagline: "A public, no-login Dorito Stats preview.",
        highlights: [
            "Week selector switches between preloaded snapshots.",
            "Core league tabs reuse the same presentation components as the live app.",
            "Mutating owner tools are shown as disabled previews only.",
        ],
    },
    weeklySnapshots: {
        2: makeWeeklySnapshot({
            week: 2,
            weekLabel: "Week 2",
            summary: {
                headline: "The opening week already looks loud.",
                reportSubtitle: "Early volatility and one runaway ceiling game.",
                reportNarrative:
                    "Northern Comets posted the top total, but Steel Kites and Signal Rams both showed enough floor to stay in the mix. The luck ledger already has a clear overperformer and one team that got dragged by bad variance.",
                reportBullets: [
                    "Northern Comets, Steel Kites, and Signal Rams are the early pace-setters.",
                    "Harbor Foxes are carrying the cleanest lineup efficiency through the first slate.",
                    "Amber Meteors have the sharpest gap between power score and luck.",
                ],
                reportClosing:
                    "This recap stays grounded in the current league snapshot.",
            },
            awards: {
                weekLabel: "Week 2",
                bestAwards: [
                    ["Most Points Scored:", "Lyra North", "177.42", true],
                    ["Best Possible Lineup:", "Owen Slate", "183.10", true],
                    ["Most TDs:", "Lyra North", "9 TDs", false],
                    ["Best Trio:", "Owen Slate", "88.4 pts", false],
                    ["Best Lineup Setter:", "Tessa Bloom", "96.2%", false],
                    ["Projection Outperformer:", "June Meridian", "+24.8", true],
                    ["Fewest inactive players:", "Lyra North", "0 inactive", false],
                    ["Best QBs:", "Mateo Quill", "44.7", false],
                    ["Best RBs:", "Priya Vale", "71.4", false],
                    ["Best WRs:", "Tessa Bloom", "82.6", false],
                    ["Best TEs:", "Lyra North", "27.4", false],
                    ["Best Flex:", "Owen Slate", "96.8", false],
                    ["Best DST:", "Idris Harbor", "18.0", false],
                    ["Best K:", "June Meridian", "16.2", false],
                    ["Best Bench:", "Idris Harbor", "58.1", false],
                ],
                worstAwards: [
                    ["Least Points Scored:", "Elliot Sage", "91.03", false],
                    ["Worst Optimal Lineup:", "June Meridian", "118.54", false],
                    ["Fewest TDs:", "Elliot Sage", "1 TD", false],
                    ["Worst Trio:", "Elliot Sage", "49.6 pts", false],
                    ["Worst Lineup Setter:", "Elliot Sage", "74.3%", false],
                    ["Projection Underperformer:", "Owen Slate", "-18.2", false],
                    ["Most inactive players:", "Elliot Sage", "4 inactive", false],
                    ["Worst QBs:", "Elliot Sage", "17.5", false],
                    ["Worst RBs:", "June Meridian", "29.8", false],
                    ["Worst WRs:", "Idris Harbor", "34.9", false],
                    ["Worst TEs:", "Elliot Sage", "5.1", false],
                    ["Worst Flex:", "Elliot Sage", "56.2", false],
                    ["Worst DST:", "Priya Vale", "2.0", false],
                    ["Worst K:", "Mateo Quill", "3.8", false],
                    ["Worst Bench:", "Mateo Quill", "21.6", false],
                ],
            },
            standings: [
                { wins: 2, losses: 0, ties: 0, pointsFor: 337.1, isPlayoffTeam: true, isByeTeam: true },
                { wins: 1, losses: 1, ties: 0, pointsFor: 329.4, isPlayoffTeam: true, isByeTeam: true },
                { wins: 1, losses: 1, ties: 0, pointsFor: 318.6, isPlayoffTeam: true },
                { wins: 1, losses: 1, ties: 0, pointsFor: 313.7, isPlayoffTeam: true },
                { wins: 1, losses: 1, ties: 0, pointsFor: 307.9 },
                { wins: 1, losses: 1, ties: 0, pointsFor: 302.6 },
                { wins: 0, losses: 2, ties: 0, pointsFor: 291.0 },
                { wins: 0, losses: 2, ties: 0, pointsFor: 276.8 },
            ],
            boxScores: [
                makeGame(0, 1, 177.42, 153.81, {
                    total: 4,
                    homeWins: 3,
                    awayWins: 1,
                    homeAvg: 161.9,
                    awayAvg: 149.2,
                    playoffMeetings: 1,
                    recent: [
                        { year: 2024, week: 11, home_score: 147.3, away_score: 139.8, winner: "home" },
                        { year: 2024, week: 6, home_score: 158.7, away_score: 160.2, winner: "away" },
                        { year: 2025, week: 2, home_score: 177.42, away_score: 153.81, winner: "home", is_current: true },
                    ],
                }),
                makeGame(2, 3, 149.17, 152.64, {
                    total: 3,
                    homeWins: 1,
                    awayWins: 2,
                    homeAvg: 150.1,
                    awayAvg: 151.0,
                    recent: [
                        { year: 2024, week: 13, home_score: 134.0, away_score: 141.8, winner: "away" },
                        { year: 2025, week: 2, home_score: 149.17, away_score: 152.64, winner: "away", is_current: true },
                    ],
                }),
                makeGame(4, 5, 128.73, 121.14, {
                    total: 2,
                    homeWins: 1,
                    awayWins: 1,
                    homeAvg: 130.4,
                    awayAvg: 126.7,
                }),
                makeGame(6, 7, 163.94, 131.77, {
                    total: 5,
                    homeWins: 4,
                    awayWins: 1,
                    homeAvg: 159.8,
                    awayAvg: 138.4,
                    playoffMeetings: 2,
                }),
            ],
            powerRankings: [
                { value: 96.18 },
                { value: 92.74 },
                { value: 89.33 },
                { value: 87.96 },
                { value: 82.51 },
                { value: 79.64 },
                { value: 73.88 },
                { value: 68.42 },
            ],
            prevPowerRankings: [
                { value: 94.6 },
                { value: 90.7 },
                { value: 88.5 },
                { value: 86.2 },
                { value: 81.1 },
                { value: 78.9 },
                { value: 74.4 },
                { value: 67.5 },
            ],
            ktcData: {
                data_week: 1,
                data: attachRoster([
                    { ktc_rank: 1, ktc_value: 91.8, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 2, ktc_value: 88.4, rank_change: 1, unmatched_players: ["Demo RB"] },
                    { ktc_rank: 3, ktc_value: 85.7, rank_change: -1, unmatched_players: [] },
                    { ktc_rank: 4, ktc_value: 83.1, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 5, ktc_value: 80.2, rank_change: 2, unmatched_players: [] },
                    { ktc_rank: 6, ktc_value: 77.9, rank_change: -1, unmatched_players: [] },
                    { ktc_rank: 7, ktc_value: 74.1, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 8, ktc_value: 71.5, rank_change: -1, unmatched_players: ["Demo WR"] },
                ]),
            },
            luckIndex: [
                { value: 0.112, factors: [{ emoji: "🎲", label: "Bounces", blurb: "A couple of late swings landed perfectly.", value: 0.061 }, { emoji: "🪄", label: "Bench Calls", blurb: "Strong swaps at kickoff.", value: 0.041 }, { emoji: "⚙️", label: "Projection", blurb: "The model underestimated the week.", value: 0.010 }] },
                { value: 0.074, factors: [{ emoji: "🧭", label: "Matchups", blurb: "Played into the softest opponent.", value: 0.034 }, { emoji: "🎯", label: "Targets", blurb: "Every receiver found enough volume.", value: 0.022 }, { emoji: "🪙", label: "Coin flips", blurb: "A few close calls went this way.", value: 0.018 }] },
                { value: 0.051, factors: [{ emoji: "⚡", label: "Explosions", blurb: "One huge touchdown run changed the line.", value: 0.028 }, { emoji: "📈", label: "Lineup fit", blurb: "Optimal slotting left nothing behind.", value: 0.017 }, { emoji: "🫶", label: "Usage", blurb: "A surprise target spike helped.", value: 0.006 }] },
                { value: 0.012, factors: [{ emoji: "🔁", label: "Variance", blurb: "Almost a perfect wash.", value: 0.004 }, { emoji: "🎛️", label: "Game script", blurb: "Neutral game environment.", value: 0.003 }, { emoji: "🧮", label: "Projection", blurb: "The forecast was close.", value: 0.005 }] },
                { value: -0.018, factors: [{ emoji: "🌧️", label: "Weather", blurb: "A wet game shaved a few points.", value: -0.006 }, { emoji: "🧱", label: "Red zone", blurb: "Drives stalled inside the 20.", value: -0.007 }, { emoji: "🧪", label: "Swing play", blurb: "A called-back score stung.", value: -0.005 }] },
                { value: -0.046, factors: [{ emoji: "🧊", label: "Cold start", blurb: "The lineup was behind by halftime.", value: -0.019 }, { emoji: "🎭", label: "Underperformance", blurb: "A few starters missed their expectations.", value: -0.017 }, { emoji: "⛔", label: "Bad break", blurb: "A long drive ended on downs.", value: -0.010 }] },
                { value: -0.083, factors: [{ emoji: "💥", label: "Explosion against", blurb: "The opponent had a monster floor game.", value: -0.034 }, { emoji: "🕳️", label: "Empty slot", blurb: "One weak spot dragged the total down.", value: -0.027 }, { emoji: "📉", label: "Projection", blurb: "The lineup missed the model.", value: -0.022 }] },
                { value: -0.121, factors: [{ emoji: "🪤", label: "Trap game", blurb: "The most painful week in the demo.", value: -0.047 }, { emoji: "🥶", label: "Variance", blurb: "A couple of bad rolls stacked up.", value: -0.039 }, { emoji: "🚫", label: "Red zone", blurb: "No touchdown luck at all.", value: -0.035 }] },
            ],
            naughtyList: {
                summary: { total_incidents: 4, owners_involved: 4, inactive_starters: 3 },
                incidents: [
                    { team: "Northern Comets", player: "Avery Quick", active_status: "inactive", position: "WR", context: "Would have won" },
                    { team: "Harbor Foxes", player: "Rowan Pike", active_status: "bye", position: "RB", context: "Would have tied" },
                    { team: "Signal Rams", player: "Noah Slate", active_status: "inactive/bye", position: "TE", context: "Bench may have saved it" },
                    { team: "Amber Meteors", player: "Iris Vale", active_status: "inactive", position: "FLEX", context: "Won anyway" },
                ],
                season_leaderboard: attachRoster([
                    { weeks_with_offense: 2, offenses: 3 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 0, offenses: 0 },
                    { weeks_with_offense: 0, offenses: 0 },
                    { weeks_with_offense: 0, offenses: 0 },
                ]),
            },
        }),
        7: makeWeeklySnapshot({
            week: 7,
            weekLabel: "Week 7",
            summary: {
                headline: "The midseason board is starting to separate.",
                reportSubtitle: "The top four look stable, but luck is still nudging the margins.",
                reportNarrative:
                    "Quartz Wolves and Harbor Foxes are hanging around the playoff edge, while the bottom half is stuck trying to turn good process into better results. The luck table shows one team getting robbed and another skating by on matchup softness.",
                reportBullets: [
                    "Northern Comets are still the only double-digit win pace.",
                    "Quartz Wolves and Harbor Foxes are inside the playoff picture by a narrow margin.",
                    "Amber Meteors remain the most volatile profile in the league.",
                ],
                reportClosing:
                    "The numbers remain intentionally synthetic so the page can load instantly without any backend calls.",
            },
            awards: {
                weekLabel: "Week 7",
                bestAwards: [
                    ["Most Points Scored:", "Lyra North", "169.12", true],
                    ["Best Possible Lineup:", "Mateo Quill", "174.66", false],
                    ["Most TDs:", "Lyra North", "8 TDs", false],
                    ["Best Trio:", "Mateo Quill", "93.1 pts", false],
                    ["Best Lineup Setter:", "Priya Vale", "97.8%", false],
                    ["Projection Outperformer:", "Tessa Bloom", "+21.5", false],
                    ["Fewest inactive players:", "Owen Slate", "0 inactive", false],
                    ["Best QBs:", "Owen Slate", "45.1", false],
                    ["Best RBs:", "Lyra North", "73.2", false],
                    ["Best WRs:", "Tessa Bloom", "84.4", false],
                    ["Best TEs:", "Priya Vale", "26.9", false],
                    ["Best Flex:", "Mateo Quill", "102.3", false],
                    ["Best DST:", "Idris Harbor", "17.6", false],
                    ["Best K:", "June Meridian", "15.9", false],
                    ["Best Bench:", "June Meridian", "61.3", false],
                ],
                worstAwards: [
                    ["Least Points Scored:", "Elliot Sage", "102.41", false],
                    ["Worst Optimal Lineup:", "Elliot Sage", "121.05", false],
                    ["Fewest TDs:", "June Meridian", "2 TDs", false],
                    ["Worst Trio:", "Elliot Sage", "58.3 pts", false],
                    ["Worst Lineup Setter:", "June Meridian", "75.5%", false],
                    ["Projection Underperformer:", "Owen Slate", "-16.1", false],
                    ["Most inactive players:", "June Meridian", "3 inactive", false],
                    ["Worst QBs:", "Elliot Sage", "18.4", false],
                    ["Worst RBs:", "June Meridian", "26.7", false],
                    ["Worst WRs:", "Idris Harbor", "37.8", false],
                    ["Worst TEs:", "Elliot Sage", "4.9", false],
                    ["Worst Flex:", "Elliot Sage", "57.6", false],
                    ["Worst DST:", "Priya Vale", "3.0", false],
                    ["Worst K:", "Mateo Quill", "4.1", false],
                    ["Worst Bench:", "Mateo Quill", "23.8", false],
                ],
            },
            standings: [
                { wins: 5, losses: 2, ties: 0, pointsFor: 1168.2, isPlayoffTeam: true, isByeTeam: true },
                { wins: 4, losses: 3, ties: 0, pointsFor: 1144.3, isPlayoffTeam: true, isByeTeam: true },
                { wins: 4, losses: 3, ties: 0, pointsFor: 1122.4, isPlayoffTeam: true },
                { wins: 4, losses: 3, ties: 0, pointsFor: 1115.7, isPlayoffTeam: true },
                { wins: 3, losses: 4, ties: 0, pointsFor: 1097.8 },
                { wins: 3, losses: 4, ties: 0, pointsFor: 1080.5 },
                { wins: 2, losses: 5, ties: 0, pointsFor: 1058.9 },
                { wins: 1, losses: 6, ties: 0, pointsFor: 1031.2 },
            ],
            boxScores: [
                makeGame(0, 4, 169.12, 152.04, {
                    total: 5,
                    homeWins: 4,
                    awayWins: 1,
                    homeAvg: 162.2,
                    awayAvg: 148.1,
                }),
                makeGame(3, 2, 157.74, 161.19, {
                    total: 4,
                    homeWins: 1,
                    awayWins: 3,
                    homeAvg: 153.7,
                    awayAvg: 158.9,
                    playoffMeetings: 1,
                }),
                makeGame(5, 7, 124.91, 126.27, {
                    total: 3,
                    homeWins: 1,
                    awayWins: 2,
                    homeAvg: 128.3,
                    awayAvg: 129.0,
                }),
                makeGame(6, 1, 164.83, 147.64, {
                    total: 6,
                    homeWins: 4,
                    awayWins: 2,
                    homeAvg: 158.8,
                    awayAvg: 150.6,
                }),
            ],
            powerRankings: [
                { value: 97.54 },
                { value: 93.28 },
                { value: 90.44 },
                { value: 88.71 },
                { value: 84.83 },
                { value: 81.27 },
                { value: 74.69 },
                { value: 69.08 },
            ],
            prevPowerRankings: [
                { value: 96.18 },
                { value: 92.74 },
                { value: 89.33 },
                { value: 87.96 },
                { value: 82.51 },
                { value: 79.64 },
                { value: 73.88 },
                { value: 68.42 },
            ],
            ktcData: {
                data_week: 6,
                data: attachRoster([
                    { ktc_rank: 1, ktc_value: 92.1, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 2, ktc_value: 89.0, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 3, ktc_value: 86.9, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 4, ktc_value: 84.0, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 5, ktc_value: 81.4, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 6, ktc_value: 78.8, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 7, ktc_value: 74.6, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 8, ktc_value: 72.0, rank_change: 0, unmatched_players: [] },
                ]),
            },
            luckIndex: [
                { value: 0.083, factors: [{ emoji: "🎲", label: "Bounces", blurb: "A few key outcomes landed in the right direction.", value: 0.032 }, { emoji: "🪄", label: "Bench", blurb: "The manager made two clean swaps.", value: 0.028 }, { emoji: "📈", label: "Projection", blurb: "The model was a little too bearish.", value: 0.023 }] },
                { value: 0.049, factors: [{ emoji: "🧊", label: "Close calls", blurb: "A narrow win masked the process.", value: 0.019 }, { emoji: "🧭", label: "Opponent", blurb: "Got a soft schedule draw.", value: 0.017 }, { emoji: "🪙", label: "Flip", blurb: "A coin-flip went the right way.", value: 0.013 }] },
                { value: 0.022, factors: [{ emoji: "⚡", label: "Ceiling", blurb: "A big play gave the line a boost.", value: 0.011 }, { emoji: "🎯", label: "Usage", blurb: "Enough target volume to keep pace.", value: 0.008 }, { emoji: "🧮", label: "Projection", blurb: "Basically right on the money.", value: 0.003 }] },
                { value: 0.008, factors: [{ emoji: "🔁", label: "Variance", blurb: "Almost a pure neutral week.", value: 0.004 }, { emoji: "🎛️", label: "Script", blurb: "The game script was normal.", value: 0.002 }, { emoji: "🪤", label: "Trap", blurb: "A small error, but not fatal.", value: 0.002 }] },
                { value: -0.015, factors: [{ emoji: "🌧️", label: "Conditions", blurb: "Weather shaved off some upside.", value: -0.005 }, { emoji: "⛔", label: "Red zone", blurb: "A drive stalled at the wrong time.", value: -0.006 }, { emoji: "🧱", label: "Usage", blurb: "One player never got rolling.", value: -0.004 }] },
                { value: -0.051, factors: [{ emoji: "🧊", label: "Swing", blurb: "The week never quite found momentum.", value: -0.018 }, { emoji: "📉", label: "Projection", blurb: "The lineup missed the forecast again.", value: -0.017 }, { emoji: "🕳️", label: "Slot", blurb: "A weak flex spot hurt the floor.", value: -0.016 }] },
                { value: -0.074, factors: [{ emoji: "💥", label: "Opponent boom", blurb: "The other side hit a huge ceiling.", value: -0.031 }, { emoji: "🥶", label: "Underuse", blurb: "Two starters came in cold.", value: -0.024 }, { emoji: "🚫", label: "Luck", blurb: "The final swing went the wrong way.", value: -0.019 }] },
                { value: -0.109, factors: [{ emoji: "🪤", label: "The trap", blurb: "The most frustrating week in the set.", value: -0.041 }, { emoji: "⚙️", label: "Execution", blurb: "The lineup missed its ceiling.", value: -0.036 }, { emoji: "🌪️", label: "Variance", blurb: "Multiple bad bounces stacked together.", value: -0.032 }] },
            ],
            naughtyList: {
                summary: { total_incidents: 5, owners_involved: 5, inactive_starters: 4 },
                incidents: [
                    { team: "Quartz Wolves", player: "Carter Drift", active_status: "inactive", position: "RB", context: "Would have won" },
                    { team: "Signal Rams", player: "Jules Finch", active_status: "inactive", position: "WR", context: "Would have tied" },
                    { team: "Amber Meteors", player: "Sage Hollow", active_status: "bye", position: "FLEX", context: "Bench may have tied it" },
                    { team: "Harbor Foxes", player: "Rory Lake", active_status: "inactive/bye", position: "TE", context: "Won anyway" },
                    { team: "Ember Owls", player: "Arlo Reed", active_status: "inactive", position: "QB", context: "Bench may not have saved it" },
                ],
                season_leaderboard: attachRoster([
                    { weeks_with_offense: 3, offenses: 5 },
                    { weeks_with_offense: 2, offenses: 3 },
                    { weeks_with_offense: 2, offenses: 3 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 0, offenses: 0 },
                    { weeks_with_offense: 0, offenses: 0 },
                ]),
            },
        }),
        12: makeWeeklySnapshot({
            week: 12,
            weekLabel: "Week 12",
            summary: {
                headline: "The demo league looks like it has a real title race.",
                reportSubtitle: "A few teams are in, a few are clinging, and one has a paper-thin path.",
                reportNarrative:
                    "The Northern Comets are the clear benchmark, but the middle of the table is still tightly stacked. The luck panel shows that signal and noise are both still affecting the race.",
                reportBullets: [
                    "Northern Comets own the best record and the best power profile.",
                    "Quartz Wolves, Harbor Foxes, and Orchard Lanterns are fighting for seeding.",
                    "Amber Meteors and Ember Owls are the main long-shot stories.",
                ],
                reportClosing:
                    "Every number stays locked to the current snapshot.",
            },
            awards: {
                weekLabel: "Week 12",
                bestAwards: [
                    ["Most Points Scored:", "Lyra North", "181.09", true],
                    ["Best Possible Lineup:", "Mateo Quill", "187.52", true],
                    ["Most TDs:", "Lyra North", "10 TDs", false],
                    ["Best Trio:", "Mateo Quill", "101.7 pts", false],
                    ["Best Lineup Setter:", "Tessa Bloom", "98.6%", false],
                    ["Projection Outperformer:", "June Meridian", "+27.1", true],
                    ["Fewest inactive players:", "Mateo Quill", "0 inactive", false],
                    ["Best QBs:", "Owen Slate", "46.3", false],
                    ["Best RBs:", "Lyra North", "75.4", false],
                    ["Best WRs:", "Tessa Bloom", "88.1", false],
                    ["Best TEs:", "Priya Vale", "31.5", false],
                    ["Best Flex:", "Mateo Quill", "119.6", false],
                    ["Best DST:", "Idris Harbor", "22.9", false],
                    ["Best K:", "June Meridian", "17.8", false],
                    ["Best Bench:", "Priya Vale", "63.9", false],
                ],
                worstAwards: [
                    ["Least Points Scored:", "Elliot Sage", "96.24", false],
                    ["Worst Optimal Lineup:", "Elliot Sage", "123.55", false],
                    ["Fewest TDs:", "Elliot Sage", "1 TD", false],
                    ["Worst Trio:", "Elliot Sage", "53.2 pts", false],
                    ["Worst Lineup Setter:", "Elliot Sage", "73.6%", false],
                    ["Projection Underperformer:", "Idris Harbor", "-19.4", false],
                    ["Most inactive players:", "Elliot Sage", "5 inactive", false],
                    ["Worst QBs:", "Elliot Sage", "18.8", false],
                    ["Worst RBs:", "June Meridian", "28.6", false],
                    ["Worst WRs:", "Idris Harbor", "39.8", false],
                    ["Worst TEs:", "Elliot Sage", "4.7", false],
                    ["Worst Flex:", "Elliot Sage", "53.2", false],
                    ["Worst DST:", "Priya Vale", "3.0", false],
                    ["Worst K:", "Mateo Quill", "4.0", false],
                    ["Worst Bench:", "Mateo Quill", "24.3", false],
                ],
            },
            standings: [
                { wins: 10, losses: 2, ties: 0, pointsFor: 1489.7, isPlayoffTeam: true, isByeTeam: true },
                { wins: 8, losses: 4, ties: 0, pointsFor: 1432.3, isPlayoffTeam: true, isByeTeam: true },
                { wins: 8, losses: 4, ties: 0, pointsFor: 1414.0, isPlayoffTeam: true },
                { wins: 7, losses: 5, ties: 0, pointsFor: 1399.6, isPlayoffTeam: true },
                { wins: 6, losses: 6, ties: 0, pointsFor: 1371.5 },
                { wins: 5, losses: 7, ties: 0, pointsFor: 1348.2 },
                { wins: 4, losses: 8, ties: 0, pointsFor: 1306.7 },
                { wins: 3, losses: 9, ties: 0, pointsFor: 1271.8 },
            ],
            boxScores: [
                makeGame(0, 3, 181.09, 159.22, {
                    total: 7,
                    homeWins: 5,
                    awayWins: 2,
                    homeAvg: 170.3,
                    awayAvg: 156.4,
                    playoffMeetings: 2,
                }),
                makeGame(4, 1, 149.33, 151.87, {
                    total: 5,
                    homeWins: 2,
                    awayWins: 3,
                    homeAvg: 148.2,
                    awayAvg: 150.9,
                }),
                makeGame(2, 5, 158.74, 146.65, {
                    total: 4,
                    homeWins: 2,
                    awayWins: 2,
                    homeAvg: 154.1,
                    awayAvg: 147.0,
                }),
                makeGame(6, 7, 163.42, 133.19, {
                    total: 6,
                    homeWins: 4,
                    awayWins: 2,
                    homeAvg: 160.6,
                    awayAvg: 139.3,
                }),
            ],
            powerRankings: [
                { value: 99.02 },
                { value: 95.31 },
                { value: 92.65 },
                { value: 89.88 },
                { value: 86.74 },
                { value: 82.43 },
                { value: 75.26 },
                { value: 70.11 },
            ],
            prevPowerRankings: [
                { value: 97.54 },
                { value: 93.28 },
                { value: 90.44 },
                { value: 88.71 },
                { value: 84.83 },
                { value: 81.27 },
                { value: 74.69 },
                { value: 69.08 },
            ],
            ktcData: {
                data_week: 11,
                data: attachRoster([
                    { ktc_rank: 1, ktc_value: 93.4, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 2, ktc_value: 90.2, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 3, ktc_value: 88.0, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 4, ktc_value: 84.8, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 5, ktc_value: 82.1, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 6, ktc_value: 79.3, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 7, ktc_value: 75.2, rank_change: 0, unmatched_players: [] },
                    { ktc_rank: 8, ktc_value: 72.8, rank_change: 0, unmatched_players: [] },
                ]),
            },
            luckIndex: [
                { value: 0.104, factors: [{ emoji: "🎲", label: "Bounces", blurb: "A few late scoring swings broke the right way.", value: 0.041 }, { emoji: "🪄", label: "Bench", blurb: "Clean swaps made the difference.", value: 0.037 }, { emoji: "📈", label: "Projection", blurb: "The model was a touch conservative.", value: 0.026 }] },
                { value: 0.067, factors: [{ emoji: "🧭", label: "Schedule", blurb: "The easiest opponent of the week.", value: 0.025 }, { emoji: "🪙", label: "Coin flip", blurb: "A close game landed on the right side.", value: 0.022 }, { emoji: "🎯", label: "Volume", blurb: "A receiver spike kept the floor high.", value: 0.020 }] },
                { value: 0.038, factors: [{ emoji: "⚡", label: "Explosion", blurb: "One huge play padded the total.", value: 0.017 }, { emoji: "📋", label: "Lineup", blurb: "The best slotting was obvious by noon.", value: 0.013 }, { emoji: "🪙", label: "Variance", blurb: "A mild assist from the bounce rate.", value: 0.008 }] },
                { value: 0.011, factors: [{ emoji: "🔁", label: "Neutral", blurb: "A mostly even, mostly expected week.", value: 0.004 }, { emoji: "🎛️", label: "Script", blurb: "The game script was pretty normal.", value: 0.004 }, { emoji: "🧮", label: "Forecast", blurb: "Right near the projection model.", value: 0.003 }] },
                { value: -0.022, factors: [{ emoji: "🌧️", label: "Conditions", blurb: "Small weather drag.", value: -0.006 }, { emoji: "⛔", label: "Red zone", blurb: "A red-zone drive evaporated.", value: -0.008 }, { emoji: "📉", label: "Projection", blurb: "The lineup missed the forecast.", value: -0.008 }] },
                { value: -0.058, factors: [{ emoji: "🧊", label: "Swing", blurb: "The week started downhill.", value: -0.021 }, { emoji: "🕳️", label: "Slot", blurb: "The flex spot was a liability.", value: -0.019 }, { emoji: "🚫", label: "Breaks", blurb: "A small break went the wrong way.", value: -0.018 }] },
                { value: -0.089, factors: [{ emoji: "💥", label: "Opponent boom", blurb: "The other roster posted a huge ceiling game.", value: -0.033 }, { emoji: "🥶", label: "Cold start", blurb: "Two starters underwhelmed early.", value: -0.030 }, { emoji: "🚫", label: "Luck", blurb: "The final swing was rough.", value: -0.026 }] },
                { value: -0.127, factors: [{ emoji: "🪤", label: "Trap", blurb: "The biggest drag in the demo set.", value: -0.049 }, { emoji: "🌪️", label: "Variance", blurb: "A bad roll plus a bad bounce.", value: -0.041 }, { emoji: "⚙️", label: "Execution", blurb: "The lineup missed its ceiling entirely.", value: -0.037 }] },
            ],
            naughtyList: {
                summary: { total_incidents: 4, owners_involved: 4, inactive_starters: 4 },
                incidents: [
                    { team: "Northern Comets", player: "Avery Quick", active_status: "inactive", position: "WR", context: "Would have won" },
                    { team: "Orchard Lanterns", player: "Rowan Pike", active_status: "inactive", position: "RB", context: "Would have tied" },
                    { team: "Ember Owls", player: "Noah Slate", active_status: "bye", position: "TE", context: "Bench may have won it" },
                    { team: "Amber Meteors", player: "Iris Vale", active_status: "inactive/bye", position: "FLEX", context: "Won anyway" },
                ],
                season_leaderboard: attachRoster([
                    { weeks_with_offense: 3, offenses: 5 },
                    { weeks_with_offense: 2, offenses: 4 },
                    { weeks_with_offense: 2, offenses: 3 },
                    { weeks_with_offense: 2, offenses: 3 },
                    { weeks_with_offense: 1, offenses: 2 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 1, offenses: 1 },
                    { weeks_with_offense: 0, offenses: 0 },
                ]),
            },
        }),
    },
    records: {
        bestTeamStats: [
            { label: "Most wins", owner: "Lyra North", value: "12 wins" },
            { label: "Highest game score", owner: "Lyra North", value: "181.09 pts" },
            { label: "Longest win streak", owner: "Owen Slate", value: "7 games" },
            { label: "Most Points For", owner: "Lyra North", value: "124.14 pts/gm" },
            { label: "Highest Points Against", owner: "Priya Vale", value: "118.42 pts/gm" },
            { label: "Largest margin of victory", owner: "June Meridian", value: "72.18 pts" },
            { label: "Largest projection beat", owner: "June Meridian", value: "+27.10 pts" },
            { label: "Highest average lineup efficiency", owner: "Tessa Bloom", value: "91.84%" },
        ],
        worstTeamStats: [
            { label: "Most losses", owner: "Elliot Sage", value: "10 losses" },
            { label: "Lowest game score", owner: "Elliot Sage", value: "86.42 pts" },
            { label: "Longest loss streak", owner: "Elliot Sage", value: "6 games" },
            { label: "Fewest Points For", owner: "Elliot Sage", value: "97.07 pts/gm" },
            { label: "Fewest Points Against", owner: "Lyra North", value: "100.96 pts/gm" },
            { label: "Biggest loss", owner: "Idris Harbor", value: "72.18 pts" },
            { label: "Biggest underperformance", owner: "Owen Slate", value: "19.40 pts" },
            { label: "Lowest average lineup efficiency", owner: "Elliot Sage", value: "78.62%" },
        ],
        bestPositionalStats: [
            { label: "Most QB points", owner: "Owen Slate", value: "46.3 pts" },
            { label: "Most RB points", owner: "Lyra North", value: "75.4 pts" },
            { label: "Most WR points", owner: "Tessa Bloom", value: "88.1 pts" },
            { label: "Most TE points", owner: "Priya Vale", value: "31.5 pts" },
            { label: "Most D/ST points", owner: "Idris Harbor", value: "22.9 pts" },
            { label: "Most K points", owner: "June Meridian", value: "17.8 pts" },
            { label: "Most Bench points", owner: "Priya Vale", value: "63.9 pts" },
        ],
        worstPositionalStats: [
            { label: "Fewest QB points", owner: "Elliot Sage", value: "18.8 pts" },
            { label: "Fewest RB points", owner: "June Meridian", value: "28.6 pts" },
            { label: "Fewest WR points", owner: "Idris Harbor", value: "39.8 pts" },
            { label: "Fewest TE points", owner: "Elliot Sage", value: "4.7 pts" },
            { label: "Fewest D/ST points", owner: "Priya Vale", value: "3.0 pts" },
            { label: "Fewest K points", owner: "Mateo Quill", value: "4.0 pts" },
            { label: "Fewest Bench points", owner: "Mateo Quill", value: "20.4 pts" },
        ],
        season: [
            { label: "Best regular-season record", value: "10-2", owner: "Lyra North", team: "Northern Comets", note: "The benchmark for the league." },
            { label: "Most points for", value: "1,489.7", owner: "Lyra North", team: "Northern Comets", note: "Still the strongest all-around profile." },
            { label: "Best single-week score", value: "181.09", owner: "Lyra North", team: "Northern Comets", note: "Week 12 remains the ceiling." },
            { label: "Closest playoff race", value: "0.6 games", owner: "Priya Vale", team: "Orchard Lanterns", note: "The middle of the table stays tight." },
        ],
        team: [
            { label: "Most wins across active owners", value: "58", owner: "Lyra North", team: "Northern Comets", note: "Synthetic all-time owner leaderboard." },
            { label: "Most playoff appearances", value: "9", owner: "Tessa Bloom", team: "Harbor Foxes", note: "A consistent postseason profile." },
            { label: "Longest winning streak", value: "7", owner: "Owen Slate", team: "Steel Kites", note: "A clean midseason run." },
            { label: "Longest losing streak", value: "6", owner: "Elliot Sage", team: "Amber Meteors", note: "A painful stretch." },
        ],
        positional: [
            { label: "QB", owner: "Mateo Quill", team: "Quartz Wolves", value: "46.3" },
            { label: "RB", owner: "Lyra North", team: "Northern Comets", value: "75.4" },
            { label: "WR", owner: "Tessa Bloom", team: "Harbor Foxes", value: "88.1" },
            { label: "TE", owner: "Priya Vale", team: "Orchard Lanterns", value: "31.5" },
            { label: "D/ST", owner: "Idris Harbor", team: "Ember Owls", value: "22.9" },
            { label: "K", owner: "June Meridian", team: "Signal Rams", value: "17.8" },
        ],
    },
    weeklyRecords: {
        2: {
            league_records: [
                { scope: "league", key: "team_score", label: "Highest team score", direction: "best", owner: "Lyra North", year: 2025, week: 2, value: 177.42, units: "pts", previous_owner: "Owen Slate", previous_year: 2024, previous_week: 11, previous_value: 174.8 },
                { scope: "league", key: "best_trio", label: "Best Trio", direction: "best", owner: "Owen Slate", year: 2025, week: 2, value: 88.4, units: "pts", previous_owner: "Tessa Bloom", previous_year: 2024, previous_week: 8, previous_value: 84.6 },
            ],
            franchise_records: [
                { scope: "franchise", key: "team_score", label: "Highest team score", direction: "best", owner: "Lyra North", year: 2025, week: 2, value: 177.42, units: "pts", previous_owner: null, previous_year: 2024, previous_week: 9, previous_value: 169.36 },
            ],
            other_signals: [],
        },
        7: {
            league_records: [
                { scope: "league", key: "lineup_efficiency", label: "Best lineup efficiency", direction: "best", owner: "Tessa Bloom", year: 2025, week: 7, value: 1, units: "%", previous_owner: "Lyra North", previous_year: 2024, previous_week: 12, previous_value: 0.976 },
                { scope: "league", key: "bench_points", label: "Most bench points", direction: "best", owner: "Priya Vale", year: 2025, week: 7, value: 63.9, units: "pts", previous_owner: "Idris Harbor", previous_year: 2024, previous_week: 5, previous_value: 61.4 },
            ],
            franchise_records: [
                { scope: "franchise", key: "lineup_efficiency", label: "Best lineup efficiency", direction: "best", owner: "Tessa Bloom", year: 2025, week: 7, value: 1, units: "%", previous_owner: null, previous_year: 2024, previous_week: 12, previous_value: 0.976 },
            ],
            other_signals: [
                { key: "perfect_lineup", label: "Perfect lineup", owner: "Tessa Bloom", value: 1, units: "%", franchise_rank: 1, league_rank: 2 },
            ],
        },
        12: {
            league_records: [
                { scope: "league", key: "team_score", label: "Highest team score", direction: "best", owner: "Lyra North", year: 2025, week: 12, value: 181.09, units: "pts", previous_owner: "Lyra North", previous_year: 2025, previous_week: 2, previous_value: 177.42 },
                { scope: "league", key: "score_dif", label: "Largest victory margin", direction: "best", owner: "June Meridian", year: 2025, week: 12, value: 72.18, units: "pts", previous_owner: "Owen Slate", previous_year: 2024, previous_week: 6, previous_value: 68.2 },
                { scope: "league", key: "team_projection_beat", label: "Biggest projection beat", direction: "best", owner: "June Meridian", year: 2025, week: 12, value: 27.1, units: "pts", previous_owner: "Lyra North", previous_year: 2024, previous_week: 10, previous_value: 25.6 },
            ],
            franchise_records: [
                { scope: "franchise", key: "team_score", label: "Highest team score", direction: "best", owner: "Lyra North", year: 2025, week: 12, value: 181.09, units: "pts", previous_owner: null, previous_year: 2025, previous_week: 2, previous_value: 177.42 },
                { scope: "franchise", key: "score_dif", label: "Largest victory margin", direction: "best", owner: "June Meridian", year: 2025, week: 12, value: 72.18, units: "pts", previous_owner: null, previous_year: 2024, previous_week: 6, previous_value: 65.9 },
            ],
            other_signals: [
                { key: "perfect_lineup", label: "Perfect lineup", owner: "Tessa Bloom", value: 1, units: "%", franchise_rank: 1, league_rank: 2 },
            ],
        },
    },
    simulation: {
        playoffTeams: 4,
        summary: {
            headline: "Synthetic simulation snapshot",
            blurb: "The league has one clear favorite, three viable contenders, and a handful of long-shot paths.",
        },
        playoffOdds: attachRoster([
            { projected_wins: 10.8, projected_losses: 2.2, projected_ties: 0.0, projected_points_for: 1502.3, playoff_odds: 0.99 },
            { projected_wins: 8.7, projected_losses: 4.3, projected_ties: 0.0, projected_points_for: 1438.6, playoff_odds: 0.87 },
            { projected_wins: 8.2, projected_losses: 4.8, projected_ties: 0.0, projected_points_for: 1419.0, playoff_odds: 0.82 },
            { projected_wins: 7.9, projected_losses: 5.1, projected_ties: 0.0, projected_points_for: 1407.8, playoff_odds: 0.79 },
            { projected_wins: 6.7, projected_losses: 6.3, projected_ties: 0.0, projected_points_for: 1376.5, playoff_odds: 0.54 },
            { projected_wins: 5.4, projected_losses: 7.6, projected_ties: 0.0, projected_points_for: 1343.1, playoff_odds: 0.33 },
            { projected_wins: 4.2, projected_losses: 8.8, projected_ties: 0.0, projected_points_for: 1298.9, playoff_odds: 0.14 },
            { projected_wins: 3.1, projected_losses: 9.9, projected_ties: 0.0, projected_points_for: 1264.2, playoff_odds: 0.05 },
        ]),
        rankDistribution: attachRoster([
            { position_odds: [0.61, 0.23, 0.08, 0.05, 0.02, 0.01, 0.0, 0.0], playoff_odds: 0.99 },
            { position_odds: [0.15, 0.28, 0.24, 0.16, 0.09, 0.05, 0.02, 0.01], playoff_odds: 0.87 },
            { position_odds: [0.11, 0.24, 0.25, 0.19, 0.11, 0.06, 0.03, 0.01], playoff_odds: 0.82 },
            { position_odds: [0.08, 0.18, 0.23, 0.24, 0.15, 0.08, 0.03, 0.01], playoff_odds: 0.79 },
            { position_odds: [0.03, 0.09, 0.16, 0.20, 0.20, 0.16, 0.10, 0.06], playoff_odds: 0.54 },
            { position_odds: [0.01, 0.04, 0.07, 0.14, 0.18, 0.22, 0.21, 0.13], playoff_odds: 0.33 },
            { position_odds: [0.01, 0.02, 0.04, 0.08, 0.13, 0.20, 0.26, 0.26], playoff_odds: 0.14 },
            { position_odds: [0.0, 0.01, 0.02, 0.04, 0.08, 0.12, 0.18, 0.55], playoff_odds: 0.05 },
        ]),
        seedingOutcomes: attachRoster([
            { first_in_league: 0.61, first_in_division: 0.72, make_playoffs: 0.99, last_in_division: 0.00, last_in_league: 0.00 },
            { first_in_league: 0.15, first_in_division: 0.10, make_playoffs: 0.87, last_in_division: 0.02, last_in_league: 0.01 },
            { first_in_league: 0.11, first_in_division: 0.08, make_playoffs: 0.82, last_in_division: 0.03, last_in_league: 0.01 },
            { first_in_league: 0.08, first_in_division: 0.06, make_playoffs: 0.79, last_in_division: 0.04, last_in_league: 0.01 },
            { first_in_league: 0.03, first_in_division: 0.02, make_playoffs: 0.54, last_in_division: 0.11, last_in_league: 0.06 },
            { first_in_league: 0.01, first_in_division: 0.01, make_playoffs: 0.33, last_in_division: 0.18, last_in_league: 0.13 },
            { first_in_league: 0.01, first_in_division: 0.01, make_playoffs: 0.14, last_in_division: 0.26, last_in_league: 0.26 },
            { first_in_league: 0.00, first_in_division: 0.00, make_playoffs: 0.05, last_in_division: 0.36, last_in_league: 0.55 },
        ]),
    },
    history: {
        summary: {
            seasonsTracked: 3,
            weeksTracked: 39,
            ownersTracked: 8,
            coverageLabel: "39 / 39 weeks",
            coverageNote: "Complete coverage across the archived seasons.",
            refreshState: "Frozen",
            lastSync: "Last sync: June 20, 2026 5:42 PM ET",
        },
        coverage: [
            {
                season: 2025,
                span: "Weeks 1-12",
                coverage: "12 / 12",
                owners: 8,
                source: "Current season import",
                sync_status: "Fresh",
                sync_tone: "good",
                note: "Active season snapshot.",
            },
            {
                season: 2024,
                span: "Weeks 1-14",
                coverage: "14 / 14",
                owners: 8,
                source: "Archived import",
                sync_status: "Locked",
                sync_tone: "warn",
                note: "Completed year with full results.",
            },
            {
                season: 2023,
                span: "Weeks 1-13",
                coverage: "13 / 13",
                owners: 7,
                source: "Legacy import",
                sync_status: "Seeded",
                sync_tone: "soft",
                note: "Smaller backfill used to mimic older data.",
            },
        ],
        records: [
            {
                category: "Regular season",
                label: "Best record",
                value: "10-2-0",
                owner: "Lyra North",
                team: "Northern Comets",
                period: "2025",
                note: "Top seed, cleanest run, and the fewest weak weeks.",
            },
            {
                category: "Points",
                label: "Most points for",
                value: "1,489.7",
                owner: "Lyra North",
                team: "Northern Comets",
                period: "2025",
                note: "Balanced roster with no obvious scoring holes.",
            },
            {
                category: "Weekly",
                label: "Highest single-week score",
                value: "181.09",
                owner: "Lyra North",
                team: "Northern Comets",
                period: "Week 12, 2025",
                note: "Still the ceiling for the current snapshot.",
            },
            {
                category: "Streak",
                label: "Longest win streak",
                value: "7",
                owner: "Owen Slate",
                team: "Steel Kites",
                period: "2024",
                note: "A midseason run that carried the playoff push.",
            },
            {
                category: "Postseason",
                label: "Most playoff appearances",
                value: "9",
                owner: "Tessa Bloom",
                team: "Harbor Foxes",
                period: "Across all tracked seasons",
                note: "A stable postseason profile across the archived history.",
            },
            {
                category: "Rebuild",
                label: "Longest losing streak",
                value: "6",
                owner: "Elliot Sage",
                team: "Amber Meteors",
                period: "2023",
                note: "Included to make the leaderboard feel real.",
            },
        ],
        leaderboards: [
            { rank: 1, owner: "Lyra North", team: "Northern Comets", record: "58-26-0", win_percentage: 0.69, points_for: 12344.8, points_against: 10811.3, playoff_appearances: 9, titles: 2 },
            { rank: 2, owner: "Tessa Bloom", team: "Harbor Foxes", record: "49-33-1", win_percentage: 0.60, points_for: 11902.6, points_against: 11447.4, playoff_appearances: 8, titles: 1 },
            { rank: 3, owner: "Owen Slate", team: "Steel Kites", record: "45-37-0", win_percentage: 0.55, points_for: 11788.1, points_against: 11642.7, playoff_appearances: 7, titles: 1 },
            { rank: 4, owner: "Priya Vale", team: "Orchard Lanterns", record: "44-38-0", win_percentage: 0.54, points_for: 11644.9, points_against: 11702.8, playoff_appearances: 6, titles: 0 },
        ],
        rivalries: [
            {
                name: "Skyline Rivalry",
                owner_a: "Lyra North",
                owner_b: "Tessa Bloom",
                record: "5-5",
                meetings: 10,
                current_streak: "Tied series",
                last_meeting: "Week 12, 2025",
                note: "Usually swings on late injuries or waiver luck.",
            },
            {
                name: "Boardroom Bowl",
                owner_a: "Owen Slate",
                owner_b: "Priya Vale",
                record: "4-3",
                meetings: 7,
                current_streak: "Owen 1",
                last_meeting: "Week 10, 2025",
                note: "A slower, high-floor matchup that stays close.",
            },
            {
                name: "Signal Derby",
                owner_a: "June Meridian",
                owner_b: "Idris Harbor",
                record: "6-4",
                meetings: 10,
                current_streak: "June 2",
                last_meeting: "Week 11, 2025",
                note: "High-variance lineups and many one-score finishes.",
            },
        ],
        aliases: [
            {
                owner: "Lyra North",
                current_alias: "Northern Comets",
                aliases: ["Comet Commander", "North Star"],
                active_since: 2024,
                note: "Current display name is resolved everywhere.",
            },
            {
                owner: "Tessa Bloom",
                current_alias: "Harbor Foxes",
                aliases: ["Harbor Bloom", "Fox Den"],
                active_since: 2024,
                note: "Team name has been stable across the active seasons.",
            },
            {
                owner: "Owen Slate",
                current_alias: "Steel Kites",
                aliases: ["Slate Office", "Kite Office"],
                active_since: 2025,
                note: "Synthetic rename history to mimic a live league record.",
            },
            {
                owner: "Priya Vale",
                current_alias: "Orchard Lanterns",
                aliases: ["Lantern Vale"],
                active_since: 2023,
                note: "Imported alias with one older alternate name.",
            },
        ],
        seasons: [
            {
                season: 2025,
                status: "Live",
                weeks: "1-12",
                owners: 8,
                playoff_teams: 4,
                champion: "Northern Comets",
                sync_status: "Fresh",
                sync_tone: "good",
                note: "Current season snapshot.",
            },
            {
                season: 2024,
                status: "Complete",
                weeks: "1-14",
                owners: 8,
                playoff_teams: 4,
                champion: "Harbor Foxes",
                sync_status: "Locked",
                sync_tone: "warn",
                note: "Full archive with complete standings.",
            },
            {
                season: 2023,
                status: "Imported",
                weeks: "1-13",
                owners: 7,
                playoff_teams: 4,
                champion: "Quartz Wolves",
                sync_status: "Seeded",
                sync_tone: "soft",
                note: "Legacy import trimmed to a smaller field.",
            },
        ],
        refreshStatus: {
            lastRefresh: "June 20, 2026 5:42 PM ET",
            source: "Static demo fixture",
            state: "Frozen",
            coverage: "3 seasons / 39 weeks",
            note: "This history snapshot is pinned until the next refresh.",
            audit: [
                { label: "Snapshot", value: "Current season plus two archived years" },
                { label: "Sync mode", value: "Read-only" },
                { label: "Backfill", value: "Disabled" },
            ],
        },
    },
    cup: demoCup,
    settings: {
        discord: {
            enabled: true,
            webhook: "https://example.invalid/webhooks/demo-only",
            note: "Webhook URL stored in league settings.",
        },
        leagueContext:
            "Lyra North manages the Northern Comets and is defending the league lead. Tessa Bloom and Owen Slate are the closest title threats, while Priya Vale and June Meridian tend to shape the playoff bubble. Rivalry notes should keep the tone specific, but avoid inventing trades or injury updates.",
    },
};

export { roster, weekLabels, weekOptions, sharedPositionMatrix, sharedTeamCards, demoLeagueData };
export default demoLeagueData;
